import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section motion-section" id="home">
      {/* Dynamic Background Glass & Mesh Blobs */}
      <div className="mesh-gradient mesh-top-left"></div>
      <div className="mesh-gradient mesh-center-right"></div>
      <div className="circuit-lines-bg"></div>

      <div className="hero-container">
        {/* LEFT COLUMN: Text, CTA & Ratings */}
        <div className="hero-left">
          <div className="tag-badge">
            <span>Secure digital wallet for everyday life</span>
          </div>

          <h1 className="hero-headline">
            Pay Smarter.<br />
            Live Better.<br />
            <span className="brand-text">ATZ Pay.</span>
          </h1>

          <p className="hero-subtext">
            Buy, store, send, and grow your money from one secure wallet. ATZ Pay brings fast payments and simple digital assets together.
          </p>

          <div className="hero-buttons">
            <button className="btn-get-started">Create wallet</button>
            <button className="btn-watch-video">
              <span className="play-circle">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
              Explore wallet
            </button>
          </div>

          <div className="trust-row">
            <div className="avatar-group">
              <img src="https://i.pravatar.cc/100?img=12" alt="User 1" />
              <img src="https://i.pravatar.cc/100?img=33" alt="User 2" />
              <img src="https://i.pravatar.cc/100?img=47" alt="User 3" />
              <img src="https://i.pravatar.cc/100?img=68" alt="User 4" />
              <img src="https://i.pravatar.cc/100?img=15" alt="User 5" />
            </div>
            <div className="rating-content">
              <span className="trust-title">Trusted by thousands of happy users</span>
              <div className="stars-row">
                <span className="stars">★★★★★</span>
                <span className="score">4.8/5</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN: Mockup Phone & Floating Glass Feature Cards */}
        <div className="hero-right">
          {/* Floating Gold Coin Accents */}
          <div className="floating-coin coin-1">🪙</div>
          <div className="floating-coin coin-2">💰</div>

          <div className="phone-wrapper">
            <div className="phone-frame">
              {/* Dynamic Island Notch */}
              <div className="dynamic-island"></div>

              {/* Status Bar */}
              <div className="phone-topbar">
                <span>9:41</span>
                <div className="status-icons">
                  <span className="signal-icon">📶</span>
                  <span className="battery-icon">🔋</span>
                </div>
              </div>

              {/* App Screen Header */}
              <div className="app-screen-header">
                <img src="https://i.pravatar.cc/100?img=20" alt="Avatar" className="app-user-avatar" />
                <div className="app-top-actions">
                  <span className="icon-btn">🔲</span>
                  <span className="icon-btn">🔔</span>
                </div>
              </div>

              {/* Bottom Fixed Navigation Bar */}
              <div className="phone-bottom-nav">
                <div className="nav-tab active">
                  <span className="tab-icon">🏠</span>
                  <span className="tab-label">Home</span>
                </div>
                <div className="nav-tab">
                  <span className="tab-icon">🔲</span>
                  <span className="tab-label">Scan</span>
                </div>
                <div className="nav-tab">
                  <span className="tab-icon">🧾</span>
                  <span className="tab-label">Bills</span>
                </div>
                <div className="nav-tab">
                  <span className="tab-icon">👤</span>
                  <span className="tab-label">Profile</span>
                </div>
              </div>
            </div>

            {/* Overlapping App Feature Cards Container */}
            <div className="overlapping-cards-row">
              {/* Card 1: Pay to QR */}
              <div className="glass-feature-card focus-card">
                <div className="card-qr-graphic">
                  <div className="qr-box-outline">
                    <div className="qr-corner top-l"></div>
                    <div className="qr-corner top-r"></div>
                    <div className="qr-corner bottom-l"></div>
                    <div className="qr-corner bottom-r"></div>
                    <svg viewBox="0 0 24 24" className="qr-svg-matrix" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeWidth="2" d="M4 4h4v4H4zM16 4h4v4h-4zM4 16h4v4H4zM14 12h2v2h-2zM10 10h4v2h-4zM14 16h4v4h-4z" />
                    </svg>
                  </div>
                </div>
                <h4>Pay to QR</h4>
              </div>

              {/* Card 2: Send Money */}
              <div className="glass-feature-card">
                <div className="card-illustration green-tint">
                  <svg viewBox="0 0 64 64" className="card-svg">
                    <circle cx="32" cy="32" r="30" fill="#E8F5E9" />
                    <path d="M20 38c4 4 12 4 12 0s-4-12 4-12" stroke="#4CAF50" strokeWidth="4" strokeLinecap="round" fill="none"/>
                    <circle cx="44" cy="24" r="6" fill="#81C784" />
                  </svg>
                </div>
                <h4>Send money</h4>
              </div>

              {/* Card 3: Pay Bills */}
              <div className="glass-feature-card">
                <div className="card-illustration purple-tint">
                  <svg viewBox="0 0 64 64" className="card-svg">
                    <rect x="18" y="12" width="28" height="40" rx="4" fill="#F3E5F5" />
                    <circle cx="32" cy="26" r="8" fill="#BA68C8" />
                  </svg>
                </div>
                <h4>Pay Bills</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM FEATURE PILLS ROW */}
      <div className="hero-bottom-pills-container">
        <div className="bottom-pills-grid">
          {/* Pill 1: Fast Transfers */}
          <div className="bottom-glass-pill">
            <div className="pill-media yellow-bg">
              <span className="pill-emoji">⏱️</span>
            </div>
            <div className="pill-text-content">
              <h3>Fast Transfers</h3>
              <p>Send money instantly to anyone, anywhere.</p>
            </div>
          </div>

          {/* Pill 2: Secure Payments */}
          <div className="bottom-glass-pill">
            <div className="pill-media green-bg">
              <span className="pill-emoji">🛡️</span>
            </div>
            <div className="pill-text-content">
              <h3>Secure Payments</h3>
              <p>Multi-layered security for peace of mind.</p>
            </div>
          </div>

          {/* Pill 3: Integrated Billing */}
          <div className="bottom-glass-pill">
            <div className="pill-media cyan-bg">
              <span className="pill-emoji">⚡</span>
            </div>
            <div className="pill-text-content">
              <h3>Integrated Billing</h3>
              <p>Pay all your utility bills in one place.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;